function padTwo(value) {
  return String(value).padStart(2, '0');
}

function isValidDateParts(day, month, year) {
  if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(year)) {
    return false;
  }

  if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31) {
    return false;
  }

  const candidate = new Date(Date.UTC(year, month - 1, day));
  return candidate.getUTCFullYear() === year
    && candidate.getUTCMonth() === month - 1
    && candidate.getUTCDate() === day;
}

export function formatIsoDateForDisplay(value = '') {
  const normalized = String(value || '').trim();
  const match = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return '';
  }

  const [, yearPart, monthPart, dayPart] = match;
  return `${dayPart}.${monthPart}.${yearPart}`;
}

export function normalizeDateInputDisplay(rawValue = '') {
  const normalized = String(rawValue || '').trim();
  if (!normalized) {
    return '';
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
    return formatIsoDateForDisplay(normalized);
  }

  const digits = normalized.replace(/\D/g, '').slice(0, 8);
  if (!digits) {
    return '';
  }

  if (digits.length <= 2) {
    return digits;
  }

  if (digits.length <= 4) {
    return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  }

  return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
}

export function parseDateInputToIso(rawValue = '') {
  const normalized = String(rawValue || '').trim();
  if (!normalized) {
    return '';
  }

  const isoMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (isoMatch) {
    const [, yearPart, monthPart, dayPart] = isoMatch;
    const day = Number(dayPart);
    const month = Number(monthPart);
    const year = Number(yearPart);
    return isValidDateParts(day, month, year)
      ? `${yearPart}-${monthPart}-${dayPart}`
      : '';
  }

  const parts = normalized.split(/[.\-/\s]+/).filter(Boolean);
  if (parts.length === 3) {
    const startsWithYear = parts[0].length === 4;
    const day = Number(startsWithYear ? parts[2] : parts[0]);
    const month = Number(parts[1]);
    const year = Number(startsWithYear ? parts[0] : parts[2]);

    if (!isValidDateParts(day, month, year)) {
      return '';
    }

    return `${year}-${padTwo(month)}-${padTwo(day)}`;
  }

  const digits = normalized.replace(/\D/g, '').slice(0, 8);
  if (digits.length !== 8) {
    return '';
  }

  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const year = Number(digits.slice(4, 8));
  if (!isValidDateParts(day, month, year)) {
    return '';
  }

  return `${year}-${padTwo(month)}-${padTwo(day)}`;
}